import {
  styled,
  secondaryFontFamily,
  ThemeType,
} from '@openeducation/oe-rn-themes';
import React, { memo } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import {
  AnimatedCircularProgress,
  AnimatedCircularProgressProps,
} from 'react-native-circular-progress';
import { useTheme } from 'react-native-paper';

import { OEText } from '../../atoms/oe-text/oe-text';

export interface CircularProgressProps extends AnimatedCircularProgressProps {
  value: number | string;
  valueFontSize?: number;
  style?: StyleProp<ViewStyle>;
}

const CircularProgress = ({
  value,
  valueFontSize = 24,
  style,
  ...rest
}: CircularProgressProps) => {
  const theme = useTheme();
  return (
    <CircleWrapper size={rest.size as number} style={style}>
      <AnimatedCircularProgress
        {...rest}
        width={rest.width || 8}
        rotation={0}
        backgroundWidth={rest.backgroundWidth || 5}
        backgroundColor={rest.backgroundColor || theme.colors.border}
      >
        {() => (
          <Value fontSize={valueFontSize} isZero={value === 0}>
            {value}
          </Value>
        )}
      </AnimatedCircularProgress>
    </CircleWrapper>
  );
};

const CircleWrapper = styled.View<{ size?: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: ${({ size }) => size && size / 2}px;
  background-color: ${({ theme }) => theme.color.background};
`;

type ValueType = {
  theme: ThemeType;
  isZero?: boolean;
};

const Value = styled(OEText).attrs<ValueType>(
  ({ theme, isZero }: ValueType) => ({
    fontFamily: secondaryFontFamily,
    fontType: 'bold',
    textAlign: 'center',
    color: isZero ? theme.color.dark3 : theme.color.text,
  })
)<ValueType>``;

export default memo(CircularProgress);
